// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CreateAdvice h1[data-v-0adf6c0a] {\n  font-size: 24px;\n  font-weight: 500;\n  padding: 50px 0 38px 0;\n}\n.CreateAdvice .contents[data-v-0adf6c0a] {\n  padding: 0 24px 40px 24px;\n}\n.CreateAdvice .contents textarea[data-v-0adf6c0a] {\n  height: 120px;\n}", ""]);
// Exports
module.exports = exports;
